import "babel-polyfill";
import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import createPalette from '@material-ui/core/styles/createPalette';
import './App.css';
import Order from './components/Order'
import Faq from './components/Faq'
import Index from './components/Index'
import PrinterMapWidget  from './components/PrinterMapWidget.js';
import SinglePrinterMapWidget from './components/SinglePrinterMapWidget';
import PartnerMapWidget from './components/PartnerMapWidget';
import Printers from './components/Printers'
import PrinterRedirect from './components/PrinterRedirect'
import OrderNew from "./components/OrderNew";
import Loading from './components/Loading';

import {I18nextProvider} from 'react-i18next';
import { Suspense } from 'react';
import i18n from './i18n';
import { PhotoModeContext } from './contexts/PhotoModeContext';

const zeccerTheme = createTheme({
  palette: createPalette({
    primary: {
      main: '#ed1e79'
    },
    secondary: {
      main: '#29abe2',
      contrastText: '#fff'
    }
  }),
  typography: {
    useNextVariants: true,
  },
});

const photoTheme = createTheme({
  palette: createPalette({
    primary: {
      main: '#29abe2', // Cyan color
      contrastText: '#fff'
    },
    secondary: {
      main: '#ed1e79'
    }
  }),
  typography: {
    useNextVariants: true,
  },
});

// Utility function to set beta test flag from URL parameter
const checkAndSetBetaTestFlag = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const betaTestParam = urlParams.get('beta_test');

  if (betaTestParam !== null) {
    localStorage.setItem('beta_test', betaTestParam);
    // Remove the parameter from URL without page reload
    const newUrl = new URL(window.location);
    newUrl.searchParams.delete('beta_test');
    window.history.replaceState({}, '', newUrl);
  }
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTheme: zeccerTheme,
      appTitle: 'Zeccer Express',
      jobType: null
    };
  }

  componentDidMount() {
    // Check for beta test flag in URL parameters
    checkAndSetBetaTestFlag();
  }

  // Method to update theme and title based on job type
  setJobType = (jobType) => {
    const isPhoto = jobType === 'photo';
    this.setState({
      currentTheme: isPhoto ? photoTheme : zeccerTheme,
      appTitle: isPhoto ? 'Zeccer Photo' : 'Zeccer Express',
      jobType: jobType
    });
  };


  render() {
    const { jobType } = this.state;
    const isPhotoMode = jobType === 'photo';

    return (
      <PhotoModeContext.Provider value={{
        isPhotoMode,
        setIsPhotoMode: (value) => this.setJobType(value ? 'photo' : 'document'),
        jobType,
        setJobType: this.setJobType
      }}>
        <ThemeProvider theme={this.state.currentTheme}>
          <I18nextProvider i18n={i18n}>
            <Suspense fallback={<Loading/>}>
            <BrowserRouter>
              <div>
                <MetaTags>
                  <title>{this.state.appTitle}</title>
                </MetaTags>
                <Routes>
                  <Route path="/index" element={<Index/>} exact={true} />
                  <Route path="/faq" element={<Faq/>} exact={true} />
                  <Route path="/printer_map_widget" element={<PrinterMapWidget/>} exact={true} />
                  <Route path="/printer_map_widget/:printerId" element={<SinglePrinterMapWidget />} exact={true} />
                  <Route path="/zabka_map_widget" element={<PrinterMapWidget filterName="żabka" clusterImage="images/cluster/marker_zabka_cluster.svg"/>} exact={true} />
                  <Route path="/pp_map_widget" element={<PrinterMapWidget filterName="Poczta Polska" />} exact={true} />
                  <Route path="/partner_map_widget/:partnerName" element={<PartnerMapWidget />} exact={true} />
                  <Route path="/printers/:printerEmail" element={<PrinterRedirect />} exact />
                  <Route path="/printers/:printerId/orders/new" element={<OrderNew/>} exact={true} />
                  <Route path="/:orderId" element={<Order blikMethod="blik"/>} exact={true} />
                  <Route path="/" element={<Printers/>} exact={true} />
                </Routes>
              </div>
            </BrowserRouter>
            </Suspense>
          </I18nextProvider>
        </ThemeProvider>
      </PhotoModeContext.Provider>
    );
  }
}

export default App;
